import { msg } from "@lingui/core/macro";
import type { MessageDescriptor } from "@lingui/core";

/**
 * Translations for the seed categories (name_key → lingui message).
 * User-created categories use their literal `name`.
 */
export const CATEGORY_NAME_MESSAGES: Record<string, MessageDescriptor> = {
  "cat.food": msg`Food`,
  "cat.breakfast": msg`Breakfast`,
  "cat.lunch": msg`Lunch`,
  "cat.dinner": msg`Dinner`,
  "cat.snacks": msg`Snacks`,
  "cat.drinks": msg`Drinks`,
  "cat.groceries": msg`Groceries`,
  "cat.transport": msg`Transport`,
  "cat.fuel": msg`Fuel`,
  "cat.public_transit": msg`Public transit`,
  "cat.taxi": msg`Taxi`,
  "cat.parking": msg`Parking`,
  "cat.vehicle_maintenance": msg`Vehicle maintenance`,
  "cat.shopping": msg`Shopping`,
  "cat.clothing": msg`Clothing`,
  "cat.electronics": msg`Electronics`,
  "cat.household_items": msg`Household items`,
  "cat.beauty": msg`Beauty`,
  "cat.entertainment": msg`Entertainment`,
  "cat.movies": msg`Movies`,
  "cat.games": msg`Games`,
  "cat.sports": msg`Sports`,
  "cat.subscriptions": msg`Subscriptions`,
  "cat.hobbies": msg`Hobbies`,
  "cat.home": msg`Home`,
  "cat.rent": msg`Rent`,
  "cat.mortgage": msg`Mortgage`,
  "cat.furniture": msg`Furniture`,
  "cat.repairs": msg`Repairs`,
  "cat.utilities": msg`Utilities`,
  "cat.electricity": msg`Electricity`,
  "cat.water": msg`Water`,
  "cat.gas_bill": msg`Gas`,
  "cat.internet": msg`Internet`,
  "cat.phone": msg`Phone`,
  "cat.health": msg`Health`,
  "cat.doctor": msg`Doctor`,
  "cat.medicine": msg`Medicine`,
  "cat.dental": msg`Dental`,
  "cat.health_insurance": msg`Health insurance`,
  "cat.education": msg`Education`,
  "cat.tuition": msg`Tuition`,
  "cat.books": msg`Books`,
  "cat.courses": msg`Courses`,
  "cat.travel": msg`Travel`,
  "cat.flights": msg`Flights`,
  "cat.hotels": msg`Hotels`,
  "cat.sightseeing": msg`Sightseeing`,
  "cat.family": msg`Family`,
  "cat.childcare": msg`Childcare`,
  "cat.pets": msg`Pets`,
  "cat.allowance_given": msg`Allowance`,
  "cat.social": msg`Social`,
  "cat.gifts_given": msg`Gifts`,
  "cat.donations": msg`Donations`,
  "cat.parties": msg`Parties`,
  "cat.fees": msg`Fees & taxes`,
  "cat.bank_fees": msg`Bank fees`,
  "cat.taxes": msg`Taxes`,
  "cat.fines": msg`Fines`,
  "cat.other_expense": msg`Other`,
  "cat.salary": msg`Salary`,
  "cat.bonus": msg`Bonus`,
  "cat.investment_income": msg`Investments`,
  "cat.interest": msg`Interest`,
  "cat.gifts_received": msg`Gifts received`,
  "cat.refunds": msg`Refunds`,
  "cat.side_income": msg`Side income`,
  "cat.other_income": msg`Other`,
};
